import { useLingui } from '@lingui/react/macro';

import { Label } from '@/design_system/Label/Label';
import { RadioItemYesNo } from '@/design_system/Radio/RadioItem/RadioItem';

export const IsQuantifiableRadio = ({
  isQuantifiable,
  setIsQuantifiable,
}: {
  isQuantifiable: boolean;
  setIsQuantifiable: (isQuantifiable: boolean) => void;
}) => {
  const { t } = useLingui();

  return (
    <Label
      label={t({
        id: 'settings.actions.actions.drawer.is-quantifiable',
        message: 'Quantifiable',
      })}
    >
      <RadioItemYesNo
        name="quantifiable"
        value={isQuantifiable ? 'yes' : 'no'}
        onChange={(value) => setIsQuantifiable(value === 'yes')}
      />
    </Label>
  );
};
